// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"496":"87e00712","783":"be4f6fcb"}[chunkId] + ".chunk.css";
};